import React from 'react'
import RetourCourt from '../components/RetourCourt'

function Growing() {
  return (
    <div>
         <div>
        <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>La vie d’Ewa est apparemment monotone, mais la bande-son qui l’accompagne crée une véritable cacophonie. Au premier plan, il y a les appels d’une mère lancinante ou les tirades d’infirmières enseignantes faites sur un ton robotique. Exposée à un mélange de bons conseils, d’interdictions et de bêtises conservatrices, l’esprit d’Ewa commence à lui jouer des tours.</p>
    </div>
    <div style={{textAlign:"center"}}> <RetourCourt /></div>
    </div>
    </div>
    </div>
  )
}

export default Growing